<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_2"><span>The Twelve Kittens of Christmas</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal__And__Left_Indent">By Amy Lane</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Killian Thornton likes his downtown life, tending bar and enjoying time with his friends and community. He’d given up on passion long ago—he wasn’t cut out for grand romance or dramatic gestures. Then one night, in a characteristic act of kindness, Killian offers his couch to help a friend’s little brother find his feet in a new city, and everything Killian thought he knew about himself and his little life gets turned upside down.</p>
<p class="P_Normal">Lewis Bernard, the funny, quirky guy happy to find a spot on Killian’s couch, can’t believe his luck. After being forced to flee his parents’ house, he was afraid of what came next, but Sacramento seems to be treating him just fine. The stunningly handsome bartender who lives downstairs from his brother offers Lewis his couch and doesn’t even balk when Lewis discovers two abandoned kittens in a vacant lot as they walk home.</p>
<p class="P_Normal">Vet bills, cat food bills, litter boxes—none of it was on Killian’s Christmas agenda, but he jumps in gamely to help because all the shelters seem to be full and that’s just the kind of guy Killian is. But kittens can multiply faster than rabbits, and Killian and Lewis accidentally rescue more and more cats.</p>
<p class="P_Normal">Lewis starts to panic. He really wants to know Killian better, but with each act of kindness, Lewis falls further in love while ruining Killian’s life. How can Killian find time to fall in love with Lewis and ask him to stay if they’re inundated with destructive furry poop-machines who all seem to need a home before Christmas?</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?94146da6